export default "__VITE_ASSET__B$O4SStU__"